// Layout.tsx
import React, { Suspense, useState } from 'react';
import Router from '../routes';
import Loader from '../components/Loader';
import './Layout.scss';
import {  SideNavigation } from '@axtria/design-system-react';
import { useSelector } from 'react-redux';
import Error from '../components/ErrorLogin/ErrorLogin';
import useRoutes from '../routes/useRoutes';
import { Header } from './Header';
import { useChatHistory } from '../hooks/useChatHistory';
import ChatHistoryComponent from '../components/ChatHistory';
import { useSmartNavigation } from '../hooks/useSmartNavigation';
import { useProfileNavigation } from '../hooks/useProfileNavigation';
import { useDomainData } from '../hooks/useDomainData';

const getWorkspaceClassName = (isFerring: boolean, isFerringPreprod: boolean, isFerringQa: boolean) =>
  (isFerring || isFerringPreprod || isFerringQa) ? 'ferring-workspace' : '';

const hasNoAccess = (userInfo: any) =>
  Boolean(
    userInfo?.loggedIn &&
      (userInfo?.no_access || !userInfo?.preferredProfile) &&
      (!userInfo?.user_permissions || userInfo.user_permissions.length === 0),
  );

const MainContentBody = ({ showAccessError, contextSwitching }: { showAccessError: boolean; contextSwitching: boolean }) => {
  if (showAccessError) return <Error />;
  // Pages stay unmounted until the new workspace's data is loaded
  if (contextSwitching) return <Loader />;
  return (
    <Suspense fallback={<Loader />}>
      <Router />
    </Suspense>
  );
};

const Layout = () => {
  const { handleNavigation } = useSmartNavigation();
  const { navListSelected, brandLogoItem, activeNavItem, isFerring, isFerringPreprod, isFerringQa, poweredBy } = useRoutes();
  
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  
  // Add hooks for profile navigation and domain data
  useProfileNavigation();
  useDomainData();
  
    const winSize = 1708;
    const expandToggleIcon = window.innerWidth > winSize ? true : false;
  
  const {
    userInfo,
    showLoader,
  } = useSelector((state: any) => ({
    userInfo: state.loginResource,
    showLoader: state.navigationInfo.show_loader,
  }));

  const {
    showChatHistory,
    isNavigating,
    chatHistoryRef,
    getTeamName,
    handleNewChat,
    handleChatSelect,
    handleNavMouseOver,
    handleDelete,
    handleRename,
  } = useChatHistory();

  const handleSidebarToggle = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  const showAccessError = hasNoAccess(userInfo);

  return (
    <>
     {!userInfo || !userInfo.loggedIn ? (
       <Loader />
     ) : (
       <>
    <main id="layout" className={`layout-wrapper ${getWorkspaceClassName(isFerring, isFerringPreprod, isFerringQa)}`}>
      <div className="layout-container">
        <div className="router-sidebar">
        {!showAccessError ? (
          <SideNavigation
            key={`${userInfo?.preferredProfile}-${activeNavItem}`}
            component="div"
            selectedItem={activeNavItem}
            brandLogoItem={brandLogoItem}
            expand={isSidebarExpanded}
            onNavMouseOver={handleNavMouseOver}
            navlist={navListSelected}
             poweredBy={poweredBy}
            onSelect={(e: any) => handleNavigation(e, isNavigating)}
            showNavToggleIcon={expandToggleIcon}
            onToggle={handleSidebarToggle}
          />
        ) : null}
        </div>
        <div className={`router-main-content ${showChatHistory ? "overlay" : ""}`}>
        {!showAccessError ? (
          <ChatHistoryComponent
              showChatHistory={showChatHistory}
              chatHistoryRef={chatHistoryRef}
              userInfo={userInfo}
              getTeamName={getTeamName}
              handleNewChat={handleNewChat}
              handleChatSelect={handleChatSelect}
              handleDelete={handleDelete}
              handleRename={handleRename}
            />
          ) : null}
          <div className="main-content-header">
            <Header/>
          </div>
          
          <div className="main-content-body">
              <MainContentBody showAccessError={showAccessError} contextSwitching={!!userInfo.contextSwitching} />
          </div>
        </div>
      </div>
    </main>
       </>
     )}
     {showLoader && <Loader />}
     </>
  );
};

export default Layout;
